import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import type { StaffCreateRequest, StaffUpdateRequest } from '@/api/types'
import { staffApi } from '@/api/endpoints/staff'

export function useStaff(restaurantId?: number | null) {
  return useQuery({
    queryKey: ['staff', restaurantId],
    queryFn: () => staffApi.list(restaurantId ?? undefined),
  })
}

export function useCreateStaff() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: StaffCreateRequest) => staffApi.create(data),
    onSuccess: () => {
      toast.success('Staff member created')
      queryClient.invalidateQueries({ queryKey: ['staff'] })
    },
    onError: () => {
      toast.error('Failed to create staff member')
    },
  })
}

export function useUpdateStaff() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: StaffUpdateRequest }) =>
      staffApi.update(id, data),
    onSuccess: () => {
      toast.success('Staff member updated')
      queryClient.invalidateQueries({ queryKey: ['staff'] })
    },
    onError: () => {
      toast.error('Failed to update staff member')
    },
  })
}
